export const iconFontAwesomeAnimalsDove = (
	<i className="fa-solid fa-dove"></i>
);
